export default {
  short: {},
  large: {},
  contentModule: {
    display: 'table',
    width: '100%',
    position: 'relative',
    boxSizing: 'border-box',
  },
  contentModuleRow: {
    display: 'table-row',
  },
  contentModuleCell: {
    display: 'table-cell',
    width: '50%',
    '&$short': {
      width: '35%'
    },
    '&$large': {
      width: '65%'
    },
  },
  contentModuleCellPrice: {
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: "left"
    }
  },
}